import {Component, OnInit, Input} from '@angular/core';
import {ErrorStateMatcher} from './error-state-matcher.model';
import {FormControl} from './form-control.model';
import {RepositoryService} from '../../repository.service';
import {FormControlType} from './form-control-type.enum';

@Component({
	template: ''
})
export abstract class FormControlComponent implements OnInit {
	FormControlType = FormControlType;

	@Input()
	control: FormControl;

	@Input()
	placeholder: string;

	matcher = new ErrorStateMatcher();

	constructor() {
	}

	ngOnInit() {
		this.control;
	}
}
